// packages/ui/src/components/exactValueAttr.ts

/**
 * The attribute an `<ExactValue>` island carries with its exact text, so the embed's DOM guard can verify the
 * island without reading React internals (docs/embed-browser-translation.md).
 *
 * FROZEN FOREVER: bundles already deployed to partner pages look for this exact name, and a page can run an
 * older and a newer bundle side by side. Never rename it.
 */
export const EXACT_VALUE_ATTR = 'data-tt-exact' as const;
